import { createSlice } from "@reduxjs/toolkit";
import { fetchLawReportTableColumnNames, fetchLawReport, fetchLawStatus, 
  fetchArticleStatus, fetchInstrumentType, updateJsonStatus
 } from "../thunks";

const initialState = {
  documents: [],
  tableColumnNames: [],
  lawStatus: [],
  articleStatus: [],
  instrumentType: [],
  loading: false,
  error: null
};

const LawReportSlice = createSlice({
  name: "LawReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

    // Fetch Human Categories Table Column Names
    .addCase(fetchLawReportTableColumnNames.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchLawReportTableColumnNames.fulfilled, (state, action) => {
      state.loading = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchLawReportTableColumnNames.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(fetchLawReport.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchLawReport.fulfilled, (state, action) => {
      state.loading = false;
      state.documents = action.payload;
    })
    .addCase(fetchLawReport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })
    .addCase(fetchLawStatus.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchLawStatus.fulfilled, (state, action) => {
      state.lawStatus = action.payload;
    })
    .addCase(fetchLawStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(fetchArticleStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(fetchArticleStatus.fulfilled, (state, action) => {
      state.articleStatus = action.payload;
    })
    .addCase(fetchArticleStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(fetchInstrumentType.pending, (state) => {
      state.error = null;
    })
    .addCase(fetchInstrumentType.fulfilled, (state, action) => {
      state.instrumentType = action.payload;
    })
    .addCase(fetchInstrumentType.rejected, (state, action) => {
      state.error = action.payload;
    })
    .addCase(updateJsonStatus.pending, (state) => {
      state.error = null;
    })
    .addCase(updateJsonStatus.fulfilled, (state, action) => {
      state.documents = state.documents.map((item) => {
        item.ID == action.payload.ID ? {...item, JsonStatus: action.payload.JsonStatus} :
        action.payload
      })
    })
    .addCase(updateJsonStatus.rejected, (state, action) => {
      state.error = action.payload;
    })
  },
});

export default LawReportSlice.reducer;